// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2cGUi","noInteraction":"EventWrapper_noInteraction__3cPFh","pointerPassthrough":"EventWrapper_pointerPassthrough__dyv0V"};